import React from 'react'
import Web3 from 'web3'
import erc20abi from 'human-standard-token-abi'
import vPoolAbi from 'abi/vToken'
import { AbiItem } from 'web3-utils'

import {
  useDispatch,
  useAppState,
  setAaveBalance,
  setvPoolBalance,
  setUnderlyingBalance,
  setExchangeRate,
  setBorrowRate,
} from 'state'
import { AAVE_KOVAN, AAVE_VPOOL } from 'models'
import { fromWei, toWei } from 'web3-utils'

export function useTokenBalance() {
  const dispatch = useDispatch()
  const { provider, account } = useAppState()
  const [web3, setWeb3] = React.useState<Web3 | undefined>(undefined)

  React.useEffect(() => {
    if (provider)
      if (!web3) {
        setWeb3(new Web3(provider))
      }
    if (web3) {
      web3.eth
        .subscribe('newBlockHeaders', (error, result) => {
          if (error) console.error(error)
        })
        .on('connected', (id) => {
          console.log(`subscription id ${id}`)
        })
        .on('data', (blockheader) => {
          console.log(`block ${blockheader.number}`)
          getTokensBalance()
        })
        .on('error', console.error)
    }
  }, [provider])

  React.useEffect(() => {
    if (web3 && account) getTokensBalance()
  }, [web3, account])

  async function getTokensBalance() {
    if (web3 === undefined) return
    try {
      const aave = new web3.eth.Contract(erc20abi, AAVE_KOVAN)
      const balance = await aave.methods.balanceOf(account).call({ from: account })
      dispatch(setAaveBalance(balance))
      const vpool = new web3.eth.Contract(vPoolAbi as AbiItem[], AAVE_VPOOL)
      const vBalance = await vpool.methods.balanceOf(account).call({ from: account })
      dispatch(setvPoolBalance(vBalance))
      const exchangeRate = await vpool.methods.exchangeRateStored().call({ from: account })
      dispatch(setExchangeRate(exchangeRate))
      const underlyingBalance = await aave.methods.balanceOf(AAVE_VPOOL).call({ from: account })
      dispatch(setUnderlyingBalance(underlyingBalance))
      const borrowRate = await vpool.methods.borrowRatePerBlock().call({ from: account })
      dispatch(setBorrowRate(borrowRate))
    } catch (err) {
      console.log(`error getting aave balance: ${JSON.stringify(err)}`)
    }
  }

  async function approve() {
    if (web3)
      try {
        const erc20 = new web3.eth.Contract(erc20abi, AAVE_KOVAN)
        const allowance = await erc20.methods.allowance(account, AAVE_VPOOL).call({ from: account })
        console.log(`got allowance ${allowance} norm: ${parseFloat(fromWei(allowance))}`)
        if (parseFloat(fromWei(allowance)) < 1000000) {
          console.log(`approving`)
          await erc20.methods.approve(AAVE_VPOOL, toWei('1000000')).send({ from: account })
        }
      } catch (err) {
        console.log(`error approving ${account}: ${JSON.stringify(err)}`)
      }
  }

  return { getAaveBalance: getTokensBalance, approve }
}
